import { render, staticRenderFns } from "./DkScore.vue?vue&type=template&id=1a4a5be3&"
import script from "./DkScore.vue?vue&type=script&lang=js&"
export * from "./DkScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports